<template>
  <div class="kt-portlet kt-portlet--mobile">
    <router-view />
    <div class="kt-form">
      <!--begin::Form-->
      <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon-home"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
            <div class="row">
              <!-- Begin: ผู้ขอเบิก/ยืม-->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label-required">ผู้ขอเบิก/ยืม:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control required'"
                    :id="'cbpBorrower'"
                    :name="'cbpBorrower'"
                    :select2-options="cbpBorrowerOptions"
                    v-model="cbpBorrower"
                    @selectChange="cbpBorrowerChange"
                    ref="cbpBorrowerSelect2"
                    data-msg-required="กรุณาเลือกผู้ขอเบิก/ยืม"
                  ></select2>
                  <span class="form-text"></span>
                </div>
              </div>
              <!-- End: ผู้ขอเบิก/ยืม-->

              <!-- Begin: ตัวแทนจำหน่าย/หน่วยงาน-->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label-required">ตัวแทนจำหน่าย/หน่วยงาน:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control required'"
                    :id="'cbpAgentCode'"
                    :name="'cbpAgentCode'"
                    :select2-options="cbpAgentCodeOptions"
                    v-model="cbpAgentCode"
                    @selectChange="onAgentCodeChange"
                    ref="cbpAgentCode"
                    data-msg-required="กรุณาเลือกตัวแทนจำหน่าย/หน่วยงาน"
                  ></select2>
                  <span class="form-text"></span>
                </div>
              </div>
              <!-- End: ตัวแทนจำหน่าย/หน่วยงาน-->

              <!-- Begin: วันที่ -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label-required">วันที่:</label>
                  <div class="input-group date">
                    <input
                      disabled="true"
                      type="text"
                      class="form-control"
                      id="cbpRequestDate"
                      name="cbpRequestDate"
                      ref="cbpRequestDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End: วันที่ -->

              <!-- Begin: ชื่อ-สกุลผู้รับสินค้าแทน -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ชื่อ-สกุลผู้รับสินค้าแทน:</label>
                  <input
                    id="cbpRecipientInsteadName"
                    name="cbpRecipientInsteadName"
                    v-model="cbpRecipientInsteadName"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="ชื่อ-สกุลผู้รับสินค้าแทน"
                  />
                </div>
              </div>
              <!-- End: ชื่อ-สกุลผู้รับสินค้าแทน -->

              <!-- Begin: สกุลผู้รับสินค้าแทน -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">เบอร์โทรผู้รับสินค้าแทน:</label>
                  <input
                    id="cbpRecipientInsteadTel"
                    name="cbpRecipientInsteadTel"
                    v-model="cbpRecipientInsteadTel"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="เบอร์โทรผู้รับสินค้าแทน"
                  />
                </div>
              </div>
              <!-- End: สกุลผู้รับสินค้าแทน -->

              <!-- Begin: ประเภทใบคำร้องขอ -->
              <div class="col-xl-12">
                <div class="form-group">
                  <label class="col-3 col-form-label label-required"
                    >ประเภทใบคำร้องขอ:</label
                  >
                  <div class="col-9">
                    <div class="kt-checkbox-inline">
                      <label
                        class="kt-checkbox"
                        v-for="(plRequestTypeOption,
                        pl) in cbpRequestTypeOptions"
                        :key="pl"
                      >
                        <input
                          type="checkbox"
                          :id="'cbpRequestType'"
                          :name="'cbpRequestType'"
                          :value="plRequestTypeOption.id"
                          v-model="cbpRequestType"
                          @change="onProductTypeChange($event)"
                        />
                        <span></span>
                        {{ plRequestTypeOption.text }}
                      </label>
                    </div>
                    <span class="form-text"></span>
                  </div>
                </div>
              </div>
              <!-- End: ประเภทใบคำร้องขอ -->

              <!-- Begin: หมวดหมู่สินค้า -->
              <div class="col-xl-12">
                <div class="form-group">
                  <label class="col-3 col-form-label label-required"
                    >หมวดหมู่สินค้า:</label
                  >
                  <div class="col-9">
                    <div class="kt-radio-inline">
                      <label
                        class="kt-radio"
                        v-for="(plProductGroupOption,
                        pl) in cbpProductGroupOptions"
                        :key="pl"
                      >
                        <input
                          type="radio"
                          :id="'cbpProductGroupCode'"
                          :name="'cbpProductGroupCode'"
                          :value="plProductGroupOption.id"
                          v-model="cbpProductGroupCode"
                          @change="onProductGroupChange($event)"
                        />
                        <span></span>
                        {{ plProductGroupOption.text }}
                      </label>
                    </div>
                    <span class="form-text"></span>
                  </div>
                </div>
              </div>
              <!-- End: หมวดหมู่สินค้า -->

              <div id="Activity" class="col-xl-12 table-responsive table-checkable">
                <table class="table table-sm table-striped table-bordered table-hover" style="min-width:2250px;">
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 1%;">ลำดับ</th>
                      <th class="text-center" style="width: 6%;">สถานะ</th>
                      <th class="text-center" style="width: 8%;">
                        ประเภทสินค้า
                      </th>
                      <th class="text-center" style="width: 13%;">
                        ชื่อสินค้า
                      </th>
                      <th class="text-center" style="width: 6%;">
                        รูปภาพ
                      </th>
                      <th class="text-center" style="width: 6%;">
                        โควต้า(แบรนด์)
                      </th>
                      <th class="text-center" style="width: 5%;">จำนวน</th>
                      <th class="text-center" style="width: 15%;">
                        ตัวแทนจำหน่าย
                      </th>
                      <th class="text-center" style="width: 18%;">
                        ชื่อร้านค้า/กิจกรรม
                      </th>
                      <th class="text-center" style="width: 12%;">
                          หมายเหตุกิจกรรม
                          <i class="far fa-copy" 
                          style="cursor: pointer; margin-left: 5px;transform: scaleX(-1);color: #5867dd;" 
                          @click="copyNote" title='คัดลอกข้อความ "หมายเหตุกิจกรรม" ของแถวที่1'></i>
                      </th>
                      <th class="text-center" style="min-width: 160px !important">
                        วันที่กำหนดคืน
                      </th>
                      <th class="text-center" style="width: 2%;">การจัดการ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="plItems == null || plItems.length == 0">
                      <td colspan="12" class="text-muted text-center">
                        คลิก + เพื่อเพิ่มรายการใหม่
                      </td>
                    </tr>
                    <template v-for="(item, i) in plItems">
                      <pl-item-row
                        ref="plItems"
                        :key="i"
                        :rowIndex="i"
                        :item="item"
                        @removeItem="onRemoveItemClick"
                      ></pl-item-row>
                    </template>
                  </tbody>
                  <tfoot>
                    <tr>
                      <th colspan="5" style="text-align:right;">
                        จำนวนรวมมูลค่าการเบิกยืม (บาท)
                      </th>
                      <th style="text-align:center;">
                        {{ totalCal | currency("฿", 2) }}
                      </th>
                    </tr>
                    <tr>
                      <td colspan="12">
                        <button
                          type="button"
                          class="btn btn-sm btn-brand"
                          @click.prevent="onAddItemClick"
                        >
                          <i class="fa fa-plus"></i> เพิ่มรายการใหม่
                        </button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label>หมายเหตุ:</label>
                  <textarea
                    placeholder="หมายเหตุ"
                    class="form-control"
                    v-model="cbpRemark"
                    rows="5"
                  ></textarea>
                  <span class="form-text"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="kt-portlet__foot">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="$router.go(-1)"
          >
            <i class="la la-close"></i> ย้อนกลับ
          </button>
          <button type="submit" class="btn btn-primary" data-dismiss="modal">
            <i class="la la-save"></i> บันทึกข้อมูล
          </button>
          <!-- <button type="button" class="btn btn-success">
            <i class="flaticon-paper-plane-1"></i> ส่งขออนุมัติ
          </button>-->
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import select2 from "../../Shared/Select2";
import datepicker from "../../Shared/Datepicker";
import plItemRow from "./ProductLoanItemRow";

export default {
  components: {
    select2,
    datepicker,
    plItemRow,
  },
  data: function() {
    var self = this;

    return {
      isChange: true,
      plItems: [],
      i: 0,
      cbpDocNumber: null,
      cbpAgentCode: null,
      cbpBorrower: null,
      //cbpCompanyProfile: null,
      cbpRecipientInsteadName: null,
      cbpRecipientInsteadTel: null,
      cbpRequestDate: null,
      cbpRequestType: [],
      cbpRequestTypeOptions: [],
      cbpProductGroupCode: null,
      cbpProductGroupId: null,
      cbpProductGroupOptions: [],
      cbpRemark: null,
      cbpAmount: null,
      cbpIsAgent: false,
      //config
      cbpAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductLoan/Select2SearchAgentOrg",
          data: function(params) {
            var query = {
              userId: self.cbpBorrower,
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },

          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cbpBorrowerOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/ProductLoan/Select2Borrower",
          data: function(params) {
            var query = {
              userId: "",
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    onAddItemClick(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      for (var i = 0; i < this.plItems.length; i++) {
        this.plItems[i].index = i;
      }

      let len = this.plItems.length + 1;

      this.plItems.push({
        index: len,
        plStatus: null,
        plProductId: null,
        plProductType: null,
        plQuota: null,
        plQty: 0,
        plPrice: 0,
        plAvgPrice: 0,
        plInitialPrice: 0,
        plAgent: null,
        plShopId: null,
        plShopActivityId: null,
        plActivityId: null,
        plIsShop: false,
        plActivityIdRemark: null,
        plReturnDate: null,
        plAvailableQty: 0,
        selectedStatusCodeData: null,
        selectedProductData: null,
        selectedProductTypeData: null,
        selectedQuotaData: null,
        selectedAgentData: null,
        selectedShopData: null,
        selectedActivityData: null,
      });

      // console.log(this.plItems)
      // for (var i = 0; i < this.plItems.length; i++) {
      //   console.log(this.plItems[i].index);
      // }
    },
    onRemoveItemClick(i, delItem) {
      // console.log("index : " + i);
      var self = this;
      self.plItemsTemp = self.plItems;
      self.plItems = [];
      self.plItemsTemp.splice(i, 1);
      self.isChange = false;
      // self.isChange = true;
      /*=== Binding items=== */
      setTimeout(function() {
        self.plItems = self.plItemsTemp;

        setTimeout(function() {
          for (let i = 0; i < self.plItems.length; i++) {
            /*=== Check Is Shop & Set Selected Select2=== */
            if ((self.plItems[i].plShopId === null && self.plItems[i].plActivityId === null) || self.plItems[i].plShopActivityId === null) {
              self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData({
                id: "0",
                text: "ไม่ระบุ",
              });
            } else if (self.plItems[i].plActivityId != null) {
              self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData(
                self.plItems[i].selectedActivityData
              );
            } else {
              self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData(
                self.plItems[i].selectedShopData
              );
            }

            /*=== Check Is Agent & Set Selected Select2=== */
            if (self.plItems[i].plAgent === null) {
              self.$refs.plItems[i].$refs.plAgent.setSelectedData({
                id: "0",
                text: "ไม่ระบุ",
              });
            }
            if (self.plItems[i].plAgent !== null) {
              self.$refs.plItems[i].$refs.plAgent.setSelectedData(
                self.plItems[i].selectedAgentData
              );
            }

            /*=== Status : Set Selected Select2=== */
            self.$refs.plItems[i].$refs.plStatus.setSelectedData(
              self.plItems[i].selectedStatusCodeData
            );

            /*=== ProductId : Set Selected Select2=== */
            self.$refs.plItems[i].$refs.plProductId.setSelectedData(
              self.plItems[i].selectedProductData
            );
            /*=== ProductType : Set Selected Select2=== */
            self.$refs.plItems[i].$refs.plProductType.setSelectedData(
              self.plItems[i].selectedProductTypeData
            );

            /*=== Quota : Set Selected Select2=== */
            self.$refs.plItems[i].$refs.plQuota.setSelectedData(
              self.plItems[i].selectedQuotaData
            );

            /*=== Set DatePicker ReturnDate=== */
            if (self.plItems[i].plReturnDate != null) {
              $(self.$refs.plItems[i].$refs.plReturnDate).datepicker(
                "update",
                self.plItems[i].plReturnDate.format("DD/MM/YYYY")
              );
            }
          }
        }, 50);
      }, 50);
    },
    onProductTypeChange: function(e) {
      // console.log("TypeChange");
    },
    onProductGroupChange: function() {
      // console.log("GroupChange");
      var self = this;
      if (self.cbpProductGroupCode === "PRODUCT_LOAN_PRODUCT_GROUP_SPARE") {
        self.cbpProductGroupId = "1";
      }
      if (self.cbpProductGroupCode === "PRODUCT_LOAN_PRODUCT_GROUP_PREMIUMS") {
        self.cbpProductGroupId = "2";
      }

      //Clear Product,Status select2 Item
      setTimeout(function() {
        for (let i = 0; i < self.plItems.length; i++) {
          self.$refs.plItems[i].$refs.plProductType.setSelectedData({
            id: null,
            text: null,
          });

          self.$refs.plItems[i].$refs.plProductId.setSelectedData({
            id: null,
            text: null,
          });

          if (self.cbpIsAgent && self.cbpProductGroupId == "2") {
            self.$refs.plItems[i].$refs.plStatus.setSelectedData({
              id: null,
              text: null,
            });
          }
        }
      }, 10);
    },
    formSubmit: function(e) {
      let router = this.$router;
      let self = this;
      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      if (self.plItems.length == 0) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเพิ่มรายการ", "warning");
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดำเนินการ กรุณารอสักครู่...",
      });

      var pItems = [];
      for (let i = 0; i < self.plItems.length; i++) {
        let element = self.plItems[i];
        pItems.push({
          Index: element.index + 1,
          Status: element.plStatus,
          ProductId: element.plProductId,
          ProductType: element.plProductType,
          AgentCode: element.plAgent,
          QuotaId: element.plQuota,
          Qty: element.plQty,
          Price: element.plPrice,
          ShopId: element.plShopId,
          ActivityId: element.plActivityId,
          IsShop: element.plIsShop,
          Remark: element.plActivityRemark,
          ReturnDate:
            element.plReturnDate != null
              ? element.plReturnDate.format("DD/MM/YYYY")
              : null,
        });
      }

      axios({
        method: "post",
        url: "/Api/ProductLoan",
        data: {
          requestDocNo: null,
          agentCode: self.cbpAgentCode,
          borrower: self.cbpBorrower,
          representName: self.cbpRecipientInsteadName,
          RepresentTel: self.cbpRecipientInsteadTel,
          requestDate: self.cbpRequestDate.format("DD/MM/YYYY"),
          requestType: self.cbpRequestType,
          productGroupId: self.cbpProductGroupCode,
          amount: self.cbpAmount,
          isAgent: self.cbpIsAgent,
          productLoanItems: pItems,
          remark: self.cbpRemark,
        },
      })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    cbpBorrowerChange: function(id, text, data, ref) {
      var self = this;

      self.$refs.cbpAgentCode.setSelectedData({
        id: null,
        text: null,
      });

      setTimeout(function() {
        //Set data radio checkbox ProductLoanProductGroup
        self.cbpProductGroupOptions = [];
        axios
          .get("/Api/Variables/ProductLoanProductGroupOptions", {
            params: {
              userId: self.cbpBorrower,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              if (
                response.data.results != null &&
                response.data.results.length > 0
              ) {
                for (let i = 0; i < response.data.results.length; i++) {
                  self.cbpProductGroupOptions.push({
                    id: response.data.results[i].id,
                    text: response.data.results[i].text,
                  });
                }
              }
            } else {
              Swal.fire(
                "เกิดข้อผิดพลาด",
                "ไม่สามารถดึงข้อมูลหมวดหมู่สินค้าได้ในขณะนี้",
                "warning"
              );
              router.go(-1);
            }
          })
          .catch(function(error) {
            Swal.fire(
              "เกิดข้อผิดพลาด",
              "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลหมวดหมู่สินค้าได้ในขณะนี้",
              "error"
            );
            router.go(-1);
          })
          .then(function() {
            // always executed
            KTApp.unblockPage();
          });

        for (let i = 0; i < self.plItems.length; i++) {
          self.$refs.plItems[i].$refs.plAgent.setSelectedData({
            id: null,
            text: null,
          });
        }
      }, 10);
    },
    onAgentCodeChange: function(id, text, data, ref) {
      var self = this;
      self.cbpIsAgent = false;
      if (text !== "") {
        self.cbpIsAgent = data[0].data.agent;
        //self.cbpCompanyProfile = data[0].data.companyProfileId;
        //Set AgentCode เพราะ Id ต้อง get จาก Data
        //self.cbpAgentCode = data[0].data.id;

        setTimeout(function() {
          for (let i = 0; i < self.plItems.length; i++) {
            self.$refs.plItems[i].$refs.plAgent.setSelectedData({
              id: null,
              text: null,
            });
          }
        }, 10);
      }
    },
    copyNote() {
        Swal.fire({
            title: "คำสั่งแก้ไข หมายเหตุกิจกรรม",
            type: "warning",
            html: "กรุณายืนยันคำสั่งคัดลอกแก้ไข หมายเหตุกิจกรรม ทั้งหมดตามข้อมูลแถวที่ 1" ,
            showCancelButton: true,
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก",
            showLoaderOnConfirm: true,
        }).then((result) => {
            
            if (result.value) {
                var self = this;
                // Start copy comment
                if (self.plItems != null && self.plItems.length > 0) {
                    // copy activityRemark from 1st row.
                    let activityRemarkRow1 = self.plItems[0].plActivityRemark;
                    
                    for (let i = 1; i < self.plItems.length; i++) {
                        //self.plItems[i].plActivityRemark = activityRemarkRow1;
                        self.$set(self.plItems[i], 'plActivityRemark', activityRemarkRow1);

                    }
                }
            }
        });
    }
  },
  computed: {
    totalCal() {
      let self = this;
      var totalSum = 0;
      if (self.plItems != null && self.plItems.length > 0) {
        for (let i = 0; i < self.plItems.length; i++) {
          //เลือกใช้ราคากลางก่อน ถ้าไม่มีค่อยไปใช้ราคาเฉลี่ย
          if (self.plItems[i].plInitialPrice != 0) {
            totalSum += Number(
              self.plItems[i].plQty * self.plItems[i].plInitialPrice
            );
            self.plItems[i].plPrice = self.plItems[i].plInitialPrice;
          } else {
            totalSum += Number(
              self.plItems[i].plQty * self.plItems[i].plAvgPrice
            );
            self.plItems[i].plPrice = self.plItems[i].plAvgPrice;
          }
          self.cbpAmount = totalSum;
        }
      }
      return totalSum;
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.cbpRequestDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      startDate: moment().format("DD/MM/YYYY"), //Current day
      endDate: moment().format("DD/MM/YYYY"), //Current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    self.cbpRequestDate = moment();
    $(self.$refs.cbpRequestDate)
      .datepicker("update", self.cbpRequestDate.format("DD/MM/YYYY"))
      .on("changeDate", function(e) {
        self.cbpRequestDate = moment(e.date);
      });

    axios
      .get("/Api/Variables/Options", {
        params: {
          search: "PRODUCT_LOAN_REQUEST_TYPE",
        },
      })
      .then(function(response) {
        if (response.status == 200) {
          if (
            response.data.results != null &&
            response.data.results.length > 0
          ) {
            for (let i = 0; i < response.data.results.length; i++) {
              self.cbpRequestTypeOptions.push({
                id: response.data.results[i].id,
                text: response.data.results[i].text,
              });
            }
          }
          return self.cbpRequestTypeOptions;
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่สามารถดึงข้อมูลประเภทใบคำร้องขอได้ในขณะนี้",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลประเภทใบคำร้องขอได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });

    // set validation rules
    $(self.$refs.form).validate({
      rules: {
        cbpAgentCode: "required",
        cbpBorrower: "required",
        cbpRequestDate: "required",
        cbpRequestType: "required",
        cbpProductGroupCode: "required",
      },
      messages: {
        cbpAgentCode: "กรุณาเลือกตัวแทนจำหน่าย",
        cbpBorrower: "กรุณากรอกผู้ขอเบิก/ยืม",
        cbpRequestDate: "กรุณากรอกวันที่",
        cbpRequestType: "กรุณาเลือกประเภทใบคำร้องขอ",
        cbpProductGroupCode: "กรุณาเลือกหมวดหมู่สินค้า",
      },
    });
    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style>
td {
  font-size: 14.5px !important;
}
.input-group-append > .input-group-text, td.form-group > input[type=number],
td > .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
@media print {
  @page {
    size: A4 landscape;
    margin-left: 15px;
    margin-right: 15px;
  }
  body {
    transform: scale(0.73) !important;
    transform-origin: top left !important;
    min-width: 2250px !important;
    height: 200% !important;
  }
}
</style>



// WEBPACK FOOTER //
// App/Components/Borrow/CreateBorrowProduct.vue